// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_KNITTING_DC_REQUEST = 'FETCH_KNITTING_DC_REQUEST';
export const FETCH_KNITTING_DC_SUCCESS = 'FETCH_KNITTING_DC_SUCCESS';
export const FETCH_KNITTING_DC_FAILURE = 'FETCH_KNITTING_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_IN_KNITTING_DC_REQUEST = 'FETCH_YARN_PO_IN_KNITTING_DC_REQUEST';
export const FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS = 'FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS';
export const FETCH_YARN_PO_IN_KNITTING_DC_FAILURE = 'FETCH_YARN_PO_IN_KNITTING_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_KNITTING_DC_REQUEST = 'CREATE_KNITTING_DC_REQUEST';
export const CREATE_KNITTING_DC_SUCCESS = 'CREATE_KNITTING_DC_SUCCESS';
export const CREATE_KNITTING_DC_FAILURE = 'CREATE_KNITTING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_KNITTING_DC = 'CREATE_USER_FORM_KNITTING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_KNITTING_DC_REQUEST = 'UPDATE_KNITTING_DC_REQUEST';
export const UPDATE_KNITTING_DC_SUCCESS = 'UPDATE_KNITTING_DC_SUCCESS';
export const UPDATE_KNITTING_DC_FAILURE = 'UPDATE_KNITTING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_KNITTING_DC_REQUEST = 'FETCH_SINGLE_KNITTING_DC_REQUEST';
export const FETCH_SINGLE_KNITTING_DC_SUCCESS = 'FETCH_SINGLE_KNITTING_DC_SUCCESS';
export const FETCH_SINGLE_KNITTING_DC_FAILURE = 'FETCH_SINGLE_KNITTING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_KNITTING_DC_REQUEST = 'DELETE_KNITTING_DC_REQUEST';
export const DELETE_KNITTING_DC_SUCCESS = 'DELETE_KNITTING_DC_SUCCESS';
export const DELETE_KNITTING_DC_FAILURE = 'DELETE_KNITTING_DC_FAILURE';

// USERFORM RESET

export const KNITTING_DC_USERFORM_RESET = 'KNITTING_DC_USERFORM_RESET';

export const NAVIGATE_KNITTING_DC_PRINT = 'NAVIGATE_KNITTING_DC_PRINT'

// navigate to unit component
export const NAVIGATE_KNITTING_DC_DETAILS = 'NAVIGATE_KNITTING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_KNITTING_DC = 'NAVIGATE_KNITTING_DC';
export const KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_KNITTING_DC_INVOICE_REQUEST = 'FETCH_KNITTING_DC_INVOICE_REQUEST';
export const FETCH_KNITTING_DC_INVOICE_SUCCESS = 'FETCH_KNITTING_DC_INVOICE_SUCCESS';
export const FETCH_KNITTING_DC_INVOICE_FAILURE = 'FETCH_KNITTING_DC_INVOICE_FAILURE';

export const RESET_KNITTING_DC_INVOICE = 'RESET_KNITTING_DC_INVOICE';

// this for close All for knitting
export const CHECK_ALL_UPDATE_SUCCESS_KNITTING = 'CHECK_ALL_UPDATE_SUCCESS_KNITTING';

export const CHECK_ALL_UPDATE_REQUEST_KNITTING = 'CHECK_ALL_UPDATE_REQUEST_KNITTING';

export const CHECK_ALL_UPDATE_FALIURE_KNITTING = 'CHECK_ALL_UPDATE_FALIURE_KNITTING';

// this for close for knitting

export const CLOSE_BTN_POST_REQUEST_KNITTING = 'CLOSE_BTN_POST_REQUEST_KNITTING';
export const CLOSE_BTN_POST_SUCCESS_KNITTING = 'CLOSE_BTN_POST_SUCCESS_KNITTING';
export const CLOSE_BTN_POST_FALIURE_KNITTING = 'CLOSE_BTN_POST_FALIURE_KNITTING';



export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURES';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';


export const FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST = 'FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST';
export const FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS = 'FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS';
export const FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURE = 'FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURES';